import { makeAutoObservable } from 'mobx'
import { type INormalizedApiError } from 'shared/api'
import { type AgentActions, type IAgentActionModel } from 'entities/AgentActions'
import { type IAgentActionsErrorsAdapter } from 'widgets/AgentActions'

export class SuccessActionsErrors implements IAgentActionsErrorsAdapter {
  private _sectionError: string | null = null
  private _perAction = new Map<IAgentActionModel, string>()
  private readonly _nestedPrefix: string
  private readonly _rootKey: string

  constructor(rootKey: string) {
    this._rootKey = rootKey
    this._nestedPrefix = `settings.${rootKey}.value.`
    makeAutoObservable(this)
  }

  sync(apiErrors: INormalizedApiError | null | undefined, model: AgentActions) {
    this.clear()
    if (!apiErrors) return

    for (const [key, value] of apiErrors.entries()) {
      if (key.startsWith(this._nestedPrefix)) {
        const index = Number(key.split('.').at(-1) ?? 0)
        const action = model.actions[index]
        if (action && !this._perAction.has(action)) this._perAction.set(action, value.value)
        continue
      }

      if (key === `settings.${this._rootKey}` || key === this._nestedPrefix) {
        this._sectionError = value.value
      }
    }
  }

  clear() {
    this._sectionError = null
    this._perAction.clear()
  }

  getActionError(action: IAgentActionModel) {
    return this._perAction.get(action) ?? null
  }

  removeActionError(action: IAgentActionModel) {
    this._perAction.delete(action)
  }

  get hasNestedErrors() {
    return this._perAction.size > 0
  }

  get hasOwnSectionError() {
    return this._sectionError !== null
  }

  get sectionError(): string | null {
    if (this._sectionError) return this._sectionError
    if (this.hasNestedErrors) return 'Please complete all the fields'
    return null
  }

  removeSectionError() {
    this._sectionError = null
  }
}
